import Axios from 'axios';

export const issueToken = async (): Promise<{ token: string }> => {
  const response = await Axios.post('/session/firestore');
  return response.data;
}